/** @format */

import React, { useEffect, useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Grid, Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ConfirmDialog, ButtonLoading, Icons } from 'components';
import clsx from 'clsx';
import UploadMediaService from './services/UploadMediaServices';
import createToast from 'components/Toast/Toast';
import { api } from 'utility';

const containerHeight = 250; // in pixels

const UploadMedia = (props) => {
  const classes = useStyles();

  const {
    value,
    onChange,
    ratio,
    name,
    icon,
    placholder,
    alt,
    style,
    className,
    round,
    acceptFile = 'png, jpg, jpeg, svg',
    setImageData = () => { },
  } = props;
  const [src, setSrc] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [fileData, setFileData] = useState({});

  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  const [croppedImageUrl, setCroppedImageUrl] = React.useState(null);
  const [imageRef, setImageRef] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [crop, setCrop] = React.useState({
    unit: '%',
    width: 50,
    height: 50,
    x: 0,
    y: 0,
    // aspect: 16 / 8,
  });

  const [counter, setCounter] = useState(1); // Resolves the problem of selecting a file multiple times by changing key of input

  useEffect(() => {
    if (value) {
      setCroppedImageUrl(value);
    }
  }, [value]);

  // --FUNCTIONS--//

  const handleConfirm = async () => {
    // setOpen(false);
    if (!fileData?.blob) {
      createToast('خطا', 'لطفا قسمتی از عکس را انتخاب نمایید.', 'danger');
      return;
    }
    setLoading(true);
    const file = new File([fileData.blob], fileData.blob.name, {
      type: fileData.blob.type,
    });

    const formData = new FormData();
    formData.append('file', file);

    if (file?.size > 6000000) {
      setLoading(false);

      setOpen(false);
      // در تسک 809 با خانم قلی نیا صحبت  شد و بنا گرفتیم حجم فایل بیشتر از 6 مگ نباشد
      message = 'حجم فایل مورد نظر بیش از 6 مگابایت می باشد.';
    }
    const dataReq = {
      size: 6000000,
      type: 'IMAGE',
    };
    await UploadMediaService.getHashe(dataReq)
      .then(async (res) => {
        if (res?.result?.uploadHash?.length) {
          await api
            .post(`${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + res?.result?.uploadHash}`, formData)
            .then((result) => {
              let data = result?.data?.result;

              setImageData({
                src: croppedImageUrl,
                uploadDetails: {
                  name: data.name,
                  hash: data.hash,
                },
                uploaded: true,
              });

              createToast('موفق', 'بارگذاری تصویر با موفقیت انجام شد.', 'success');
              setLoading(false);
              setOpen(false);
              onChange(`${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + data?.hash}`);
            })
            .catch((error) => {
              setCroppedImageUrl(value);
              setLoading(false);
              createToast('خطا', 'بارگذاری تصویر ناموفق، مجددا تلاش نمایید.', 'danger');
            });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setOpen(false);
    setCroppedImageUrl(null);
  };

  const handleRemoveAvatar = () => {
    setCroppedImageUrl(null);
    onChange(null);
    setConfirmDeleteModal(false);
    setImageData((prev) => ({ ...prev, removed: true }));
  };

  const onSelectFile = (e) => {
    const fileExtension = e.target.files[0].name.split('.').pop().toLowerCase();
    const acceptedExtensions = acceptFile
      .toLowerCase()
      .split(',')
      .map((ext) => ext.trim());

    if (!acceptedExtensions.includes(fileExtension)) {
      setLoading(false);
      setOpen(false);

      return createToast(
        'خطا',
        ` فایل ارسال شده باید در فرمت های زیر باشد.
        ${acceptFile}`,
        'danger',
      );
    }
    setCounter(counter + 1);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setSrc(reader.result), setOpen(true));
      reader.readAsDataURL(e.target.files[0]);
      setOpen(true);
      setImageData({ name: e.target.files[0].name, data: e.target.files[0] });
    }
  };

  const onImageLoaded = (image) => {
    setImageRef(image);
  };

  const onCropComplete = (crop) => {
    makeClientCrop(crop);
  };

  const onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    setCrop(crop);
  };

  const makeClientCrop = async (crop) => {
    if (imageRef && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(imageRef, crop, 'newFile.png');
      setCroppedImageUrl(croppedImageUrl);
    }
  };

  const getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error('Canvas is empty');
            return;
          }

          blob.name = fileName;
          let fileUrl;
          window.URL.revokeObjectURL(fileUrl);
          fileUrl = window.URL.createObjectURL(blob);
          resolve(fileUrl);
          setFileData({ blob });
        },
        'image/png',
        1,
      );
    });
  };

  const ratioToWidth = () => {
    if (!ratio) {
      return containerHeight;
    }
    const ratios = ratio.split(':');
    const rw = parseInt(ratios[0]);
    const rh = parseInt(ratios[1]);
    return Math.round((rw * containerHeight) / rh);
  };

  return (
    <div
      className={clsx(classes.uploadPaper, className, {
        [classes.radiusRoot]: round,
      })}
      style={{ width: ratioToWidth(), maxWidth: 'calc(100vw - 109px)', ...style }}
    >
      <ConfirmDialog
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={handleRemoveAvatar}
        title="تایید حذف تصویر"
        content="آیا از حذف تصویر انتخاب شده اطمینان دارید؟"
        confirmButtonText="حذف تصویر"
        cancelButtonProps="انصراف"
      />

      {src && (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.dialogMain}
        >
          <DialogTitle className={classes.title}>انتخاب و ویرایش تصویر</DialogTitle>
          <DialogContent>
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              aspect={false}
              className={clsx({
                [classes.cropper]: round,
              })}
              onImageLoaded={onImageLoaded}
              onComplete={onCropComplete}
              onChange={(crop) => onCropChange(crop)}
            />
          </DialogContent>
          <DialogActions>
            <ButtonLoading
              variant="contained"
              onClick={handleConfirm}
              color="primary"
              autoFocus
              loading={loading}
              name="تایید"
            />
            <Button onClick={handleClose} variant="contained">
              انصراف{' '}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {!croppedImageUrl ? (
        <Grid
          className={classes.placeholder}
          alignItems="center"
          direction="column"
          justifyContent="center"
          container
          item
          xs={12}
        >
          <div className={classes.dragHereIcon}>{icon ?? <Icons icon='image' color='#303DBF' size='35' />}</div>
          <Typography className={classes.dragHereText} variant="h5" align="center">
            {placholder ?? 'تصویر را انتخاب کنید'}
          </Typography>
        </Grid>
      ) : null}
      {croppedImageUrl && (
        <img className={classes.image} alt={alt ?? 'تصویر'} src={croppedImageUrl} />
      )}
      <div className={classes.actions}>
        <Grid
          item
          xs={12}
          className={classes.actionButtons}
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          alignContent="center"
        >
          <input
            hidden
            key={counter}
            accept="image/*"
            id={name}
            type="file"
            onChange={onSelectFile}
          />
          <label htmlFor={name}>
            <Button
              // raised
              component="span"
              color="primary"
              variant="contained"
              startIcon={<Icons icon='image' color='#fff' size='23' />}
            >
              {croppedImageUrl ? 'تغییر تصویر' : 'انتخاب تصویر'}
            </Button>
          </label>
          {croppedImageUrl ? (
            <Button
              variant="contained"
              className={classes.removeButton}
              startIcon={<Icons icon='TrashPicture' color='#303DBF' size='23' />}
              onClick={() => setConfirmDeleteModal(true)}
            >
              حذف تصویر
            </Button>
          ) : null}
        </Grid>
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => {
  return {
    dialogMain: {
      '& .MuiDialog-paper': {
        borderRadius: '10px',
        overflowY: 'inherit',
      },
      '& .MuiDialogContent-root': {
        overflowY: 'auto',
        '&::scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-moz-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-thumb': {
          width: '0',
          minWidth: '0',
        },
        '&.noneOverFlow': {
          overflowY: 'inherit',
        },
      },
      '& .MuiDialogActions-root': {
        justifyContent: 'flex-start',
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: '20px',
        gap: '15px',
      },
      '& .MuiDialog-container': {
        width: '100vw',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
    },
    title: {
      margin: 0,
      padding: '20px',
      borderBottom: '1px solid #E2E5E9',

      '& h2': {
        fontSize: 16,
        color: '#0C0E10',
      },
    },
    radiusRoot: {
      borderRadius: '2px !important',
    },
    cropper: {
      '& .ReactCrop__crop-selection': {
        borderRadius: '2px !important',
      },
    },
    uploadPaper: {
      position: 'relative',
      marginInlineStart: '8px',
      background: theme.palette.grey[100],
      border: `1px dotted ${theme.palette.primary.light}`,
      //   padding: theme.spacing(6),
      boxSizing: 'border-box',
      borderRadius: 10,
      cursor: 'pointer',
      transform: 'scale(1)',
      marginInlineEnd: theme.spacing(1),
      overflow: 'hidden',
      transition: 'ease .2s transform,ease .2s border',
      height: `${containerHeight}px`,
      '&:hover': {
        borderColor: theme.palette.grey[700],
      },
      '&:active': {
        // transform: 'scale(.98)'
      },
      '& *': {
        outline: 'none',
      },
    },
    actions: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      //   background: 'red',
      opacity: 0,
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      '&:hover': {
        opacity: 1,
      },
    },
    actionButtons: {
      height: '100%',
      boxSizing: 'border-box',
      background: 'rgba(0,0,0,.2)',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      position: 'absolute',
      top: 0,
      right: 0,
    },
    placeholder: {
      width: '100%',
      height: '100%',
      padding: theme.spacing(3),
      boxSizing: 'border-box',
    },
    dragHereIcon: {
      color: theme.palette.grey[600],
    },
    dragHereText: {
      paddingTop: theme.spacing(2),
      color: theme.palette.grey[600],
    },
    fileFormat: {
      direction: 'rtl',
      fontSize: 40,
      marginBottom: 13,
      marginTop: 13,
      color: theme.palette.grey[600],
    },
    backdrop: {
      opacity: '0.4 !important',
    },
    removeButton: {
      marginTop: theme.spacing(1),
    },
  };
});

export default UploadMedia;
